/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Checkpoint_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Restore the project and the chat to before this message, then edit the message" |
*
* @param {Assistant_Checkpoint_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_checkpoint_edit_title = /** @type {((inputs?: Assistant_Checkpoint_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Checkpoint_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurez le projet et la conversation à leur état antérieur à ce message, puis modifiez le message.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stelle das Projekt und den Chat auf den Stand vor dieser Nachricht wieder her und bearbeite anschließend die Nachricht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina il progetto e la chat allo stato precedente a questo messaggio, quindi modifica il messaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановите проект и чат до состояния, предшествующего этому сообщению, затем отредактируйте сообщение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaura el proyecto y el chat al estado anterior a este mensaje y luego edita el mensaje.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请将项目和聊天记录恢复到发送此消息之前的状态，然后编辑此消息。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトとチャットをこのメッセージが表示される前の状態に復元してから、メッセージを編集してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस संदेश से पहले की स्थिति में प्रोजेक्ट और चैट को पुनर्स्थापित करें, फिर संदेश को संपादित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaure o projeto e o chat para o estado anterior a esta mensagem e, em seguida, edite a mensagem.")
	return /** @type {LocalizedString} */ ("Restore the project and the chat to before this message, then edit the message")
});